var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main-error"},[_c('q-icon',{attrs:{"size":"18px"},domProps:{"innerHTML":_vm._s(_vm.infosetSVG)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }